import type { LotStoryProjectionTimelineEvent } from '../../types/lotStory'

export type StoryTimelineEventCount = {
  eventType: LotStoryProjectionTimelineEvent['eventType']
  count: number
}

const eventTypeOrder: LotStoryProjectionTimelineEvent['eventType'][] = [
  'create',
  'update',
  'split',
  'merge',
  'move',
  'transfer'
]

export const buildStoryTimelineEventCounts = (args: {
  events: LotStoryProjectionTimelineEvent[]
}): StoryTimelineEventCount[] => {
  const countByType = new Map<LotStoryProjectionTimelineEvent['eventType'], number>()

  args.events.forEach((event) => {
    countByType.set(event.eventType, (countByType.get(event.eventType) ?? 0) + 1)
  })

  return eventTypeOrder
    .map((eventType) => ({
      eventType,
      count: countByType.get(eventType) ?? 0
    }))
    .filter((entry) => entry.count > 0)
}